import { Box, Flex, FlexProps, Icon, Text } from '@chakra-ui/react';
import { ReactComponent as ChevronLeft } from 'resources/images/chevron-left.svg';
import { ReactComponent as Info } from 'resources/images/info.svg';
import { ReactComponent as CloseIcon } from 'resources/images/close-circle.svg';
import React from 'react';

type SlimBannerVariant = 'warning' | 'info';

interface SlimBannerProps extends FlexProps {
  variant?: SlimBannerVariant;
  primaryText: React.ReactNode;
  secondaryText?: React.ReactNode;
  onClick?: () => void;
  rightSocket?: React.ReactNode;
  onClose?: () => void;
}

export const SlimBanner = ({
  primaryText,
  variant = 'info',
  secondaryText,
  onClick,
  rightSocket,
  onClose,
  ...rest
}: SlimBannerProps) => {
  return (
    <Flex
      cursor={onClick ? 'pointer' : 'auto'}
      fontSize="xs"
      fontWeight={500}
      h={50}
      px={2}
      rounded={4}
      alignItems="center"
      bg={variant === 'warning' ? 'R.20' : 'B.20'}
      onClick={onClick}
      {...rest}
    >
      <Icon
        as={variant === 'warning' ? Info : ChevronLeft}
        h={3.5}
        w={3.5}
        mr={2}
      />
      <Box flex={1}>
        <Text fontSize="xs">{primaryText}</Text>
        {secondaryText && (
          <Text fontSize="xs" opacity={0.72}>
            {secondaryText}
          </Text>
        )}
      </Box>
      <Flex alignItems="center" gap={4}>
        {rightSocket}
        {onClose && (
          <Icon
            role="button"
            data-testid="close-slim-banner-button"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            as={CloseIcon}
            color={variant === 'warning' ? 'R.50' : 'B.50'}
            height={6}
            width={6}
          />
        )}
      </Flex>
    </Flex>
  );
};
